var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1392 766L1392 794",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1392.5,
    cy: 761.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.99 761.19C1387.99 757.283 1391.29 754.117 1395.36 754.117C1395.94 754.117 1396.51 754.184 1397.06 754.308C1395.74 753.48 1394.19 753 1392.52 753C1387.81 753 1384 756.806 1384 761.5C1384 766.194 1387.81 770 1392.52 770C1394.81 770 1396.89 769.093 1398.43 767.62C1397.49 768.032 1396.45 768.263 1395.36 768.263C1391.29 768.263 1387.99 765.096 1387.99 761.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1401.4 760.6L1401.37 758.146L1399.54 759.719L1397.3 759.056L1398.11 761.337L1396.77 763.381L1399.1 763.218L1400.5 765.144L1401.13 762.763L1403.34 761.909L1401.4 760.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch4);
export default __webpack_public_path__ + "static/media/church_4.a438b3c25f78b839503377d2606d1ea3.svg";
export { ForwardRef as ReactComponent };